import { api } from "./UrlPadrao";

export enum TemDiferencaEnum {
    TODOS = 'todos',
    SIM = 'sim',
    NAO = 'nao',
}

export interface BuscarDivergenciasSATProps {
    token: string;
    cte: number;
    temDiferenca?: TemDiferencaEnum;
    previsaoEmbarqueInicio: string;
    previsaoEmbarqueFinal: string;
}

export interface DivergenciaSAT {
    idViagem: number;
    cte: number;
    freteMotoristaGerenciador: number;
    freteMotoristaSat: number;
    freteFiscalGerenciador: number;
    freteFiscalSat: number;
    pedagioGerenciador: number;
    pedagioSat: number;
    icmsGerenciador: number;
    icmsSat: number;
    usuarioResponsavel: string;
    temDiferenca: boolean;
    temDiferencaTexto: TemDiferencaEnum;
    dataUltimaVerificacao: string;
    difFreteMotorista: boolean;
    difFreteFiscal: boolean;
    difPedagio: boolean;
    difIcms: boolean;
}

export const getDivergenciasSAT = async ({
    token,
    cte,
    temDiferenca,
    previsaoEmbarqueInicio,
    previsaoEmbarqueFinal,
}: BuscarDivergenciasSATProps): Promise<DivergenciaSAT[]> => {
    const url = `divergencias-sat/${cte}` +
        (temDiferenca ? `/${temDiferenca}` : "") +
        `/${previsaoEmbarqueInicio}/${previsaoEmbarqueFinal}`;

    const response = await api.get(url, {
        headers: {
            Authorization: token,
        }
    });

    return response.data;
};

export const verificarDivergenciasSAT = async ({ token, cte }: { token: string; cte: number; }): Promise<DivergenciaSAT> => {
    const url = `divergencias-sat/verificar/${cte}`;
    const response = await api.post(url, null, {
        headers: {
            Authorization: token,
        }
    });
    return response.data;
};

export const deletarDivergenciasSAT = async ({ token, cte }: { token: string; cte: number; }): Promise<DivergenciaSAT> => {
    const url = `divergencias-sat/deletar/${cte}`;
    const response = await api.delete(url, {
        headers: {
            Authorization: token,
        }
    });
    return response.data;
};